export const JOBS_NEW_MENU_TOOLTIP = 'jobs_new_menu_tooltip';
